import { memo } from 'react'

import { ListItemIcon, Menu, MenuItem } from '@mui/material'
import { ExpandMoreOutlined, PhoneAndroid, DevicesOutlined, LaptopOutlined } from '@mui/icons-material'

import { Chip, ChipProps, usePopoverState } from '@collaborate-health/uikit'

import { AnnouncementPlatform, AnnouncementPlatformDisplayName } from '../../enums'

const AnnouncementPlatformToColorMap: Record<AnnouncementPlatform, ChipProps['color']> = {
  [AnnouncementPlatform.All]: 'success',
  [AnnouncementPlatform.Web]: 'primary',
  [AnnouncementPlatform.Mobile]: 'error',
}

const AnnouncementPlatformToIconMap: Record<AnnouncementPlatform, ChipProps['icon']> = {
  [AnnouncementPlatform.All]: <DevicesOutlined />,
  [AnnouncementPlatform.Web]: <LaptopOutlined />,
  [AnnouncementPlatform.Mobile]: <PhoneAndroid />,
}

export interface AnnouncementPlatformChipProps {
  platform: AnnouncementPlatform
  onChange?: (platform: AnnouncementPlatform) => void
}

const AnnouncementPlatformChip: React.FC<AnnouncementPlatformChipProps> = ({
  platform = AnnouncementPlatform.All,
  onChange,
}) => {
  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLDivElement>()

  return (
    <>
      <Chip
        ref={anchorRef}
        size='small'
        icon={AnnouncementPlatformToIconMap[platform]}
        color={AnnouncementPlatformToColorMap[platform]}
        label={AnnouncementPlatformDisplayName[platform]}
        onClick={onChange && onOpen}
        onDelete={onChange && onOpen}
        deleteIcon={<ExpandMoreOutlined />}
      />
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {[AnnouncementPlatform.All, AnnouncementPlatform.Web, AnnouncementPlatform.Mobile].map((value) => (
          <MenuItem
            key={value}
            selected={platform === value}
            onClick={() => {
              onClose()
              onChange?.(value)
            }}
          >
            <ListItemIcon>{AnnouncementPlatformToIconMap[value]}</ListItemIcon>
            {AnnouncementPlatformDisplayName[value]}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default memo(AnnouncementPlatformChip)

